<template>
    <div>
        <el-form :inline="true">
            <el-form-item label="交易对">
                <el-input v-model="pair"/>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="queryStrategyList(1)">查询</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="danger" @click="dialogVisible=true">增加策略</el-button>
            </el-form-item>
        </el-form>

        <el-form :inline="true">
            <el-form-item label="当前大盘方向判断">
                <el-select v-model="directionJudged">
                    <el-option v-for="item in directionTypes" :label="item.desc" :key="item.code" :value="item.code"/>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="setDirection()">设置大盘方向判断</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="hedgeStrategy">
            <el-table-column label="交易对" prop="pair"/>
            <el-table-column label="开启">
                <template slot-scope="scope">
                    <el-switch :value="scope.row.open" active-color="#13ce66" inactive-color="#ff4949"
                               @change="updateStatus(scope.row, $event)"/>
                </template>
            </el-table-column>
            <el-table-column label="行情方向判断">
                <template slot-scope="scope">{{parseCodeToDesc(scope.row.directionCode,directionTypes)}}</template>
            </el-table-column>
            <el-table-column label="目标交易所" prop="exchangeEnum"/>
            <el-table-column label="美金对冲阈值">
                <template slot-scope="scope">
                    <el-input :value="scope.row.thresholdNotPartition" style="width:100px"
                              @change="setThreshold(scope.row.pair,'thresholdNotPartition',$event)"/>
                </template>
            </el-table-column>
            <el-table-column label="顺势比例">
                <template slot-scope="scope">
                    <el-input :value="scope.row.discountConform" style="width:100px"
                              @change="setThreshold(scope.row.pair,'discountConform',$event)"/>
                </template>
            </el-table-column>
            <el-table-column label="震荡比例">
                <template slot-scope="scope">
                    <el-input :value="scope.row.discountSideways" style="width:100px"
                              @change="setThreshold(scope.row.pair,'discountSideways',$event)"/>
                </template>
            </el-table-column>
            <el-table-column label="逆势比例">
                <template slot-scope="scope">
                    <el-input :value="scope.row.discountOpposite" style="width:100px"
                              @change="setThreshold(scope.row.pair,'discountOpposite',$event)"/>
                </template>
            </el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="success" @click="saveThreshold(scope.row)">保存配置</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination background layout="prev, pager, next" :total="strategyTotal" :page-size="25"
                       :current-page="pageNo"
                       @current-change="queryStrategyList"></el-pagination>

        <el-dialog title="增加策略" :visible.sync="dialogVisible" width="40%" @close="clearData">
            <div>
                <span style="padding-right: 20px">交易对</span>
                <el-input maxlength="10" v-model="strategyData.pair" style="width: 50%" size="small"></el-input>
            </div>
            <div style="margin-top: 20px">
                <span style="padding-right: 40px">开启</span>
                <el-switch v-model="strategyData.open" active-color="#13ce66" inactive-color="#ff4949"/>
            </div>
            <div style="margin-top: 20px">
                <span style="padding-right: 48px">目标交易所</span>
                <el-select placeholder="请选择" v-model="strategyData.exchangeEnum" style="width: 50%" size="small">
                    <el-option v-for="item in exchangeEnum" :key="item.value" :label="item.label"
                               :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div style="margin-top: 20px">
                <span style="padding-right: 48px">美金对冲阈值</span>
                <el-input v-model="strategyData.thresholdNotPartition" style="width:100px"/>
            </div>
            <div style="margin-top: 20px">
                <span style="padding-right: 48px">顺势比例</span>
                <el-input v-model="strategyData.discountConform" style="width:100px"/>
            </div>
            <div style="margin-top: 20px">
                <span style="padding-right: 48px">震荡比例</span>
                <el-input v-model="strategyData.discountSideways" style="width:100px"/>
            </div>
            <div style="margin-top: 20px">
                <span style="padding-right: 48px">逆势比例</span>
                <el-input v-model="strategyData.discountOpposite" style="width:100px"/>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="addStrategy">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import api from './hedgeApi';
    import {mapState, mapActions} from "vuex";
    import {RIGHTS_TYPE} from "../../common/constant";

    export default {
        name: "HedgeStrategy",
        data() {
            return {
                pair: '',
                pageNo: '',
                directionTypes: [{code: 1, desc: '上涨'}, {code: 0, desc: '横盘'}, {code: -1, desc: '下跌'}],
                thresholdNotPartition: '',
                directionJudged: '',
                dialogVisible: false,
                exchangeEnum: [ //交易所
                    {"value": "BINANCE", "label": "BINANCE"},
                    {"value": "HUOBI", "label": "HUOBI"},
                    {"value": "GATEIO", "label": "GATEIO"},
                    {"value": "OKEX", "label": "OKEX"},
                    {"value": "FTX", "label": "FTX"},
                    {"value": "COINEX", "label": "COINEX"},
                    {"value": "ZB", "label": "ZB"}
                ],
                strategyData: { //策略数据
                    pair: "",
                    open: true,
                    exchangeEnum: "",
                    thresholdNotPartition: 0,
                    discountConform: 0,
                    discountSideways: 0,
                    discountOpposite: 0
                }
            }
        },
        computed: {
            ...mapState('tradeStatistic', ['hedgeStrategy', 'strategyTotal']),
            ...mapState(["userInfo", "userRights"])
        },
        created() {
            if (this.rightsContains('HEDGE_STRATEGY')) {
                this.queryStrategyList(1);
                this.getDirection();
            }
        },
        methods: {
            ...mapActions('tradeStatistic', ['getStrategyList']),
            queryStrategyList(val) {
                this.pageNo = val;
                this.getStrategyList({pair: this.pair, page: this.pageNo});
            },
            parseCodeToDesc(code, infos) {
                for (let index in infos) {
                    if (infos[index].code == code) {
                        return infos[index].desc;
                    }
                }
            },
            setThreshold(pair, name, amount) {
                let data = {pair: pair};
                if (name === 'thresholdNotPartition') {
                    data.thresholdNotPartition = amount;
                } else if (name === 'discountConform') {
                    data.discountConform = amount;
                } else if (name === 'discountSideways') {
                    data.discountSideways = amount;
                } else if (name === 'discountOpposite') {
                    data.discountOpposite = amount;
                }
                api.updateRiskHedgeStrategy(data).then(() => {
                    this.queryStrategyList(this.pageNo);
                })
            },
            saveThreshold(info) {
                let data = {
                    pair: info.pair,
                    thresholdNotPartition: info.thresholdNotPartition,
                    discountConform: info.discountConform,
                    discountSideways: info.discountSideways,
                    discountOpposite: info.discountOpposite,
                };
                api.updateRiskHedgeStrategy(data).then(() => {
                    this.queryStrategyList(this.pageNo);
                    this.$message.success('保存成功');
                })
            },
            setDirection() {
                api.updateCurrentDirectionJudged({direction: this.directionJudged}).then(() => {
                    this.getDirection();
                    this.$message.success('设置成功');
                })
            },
            getDirection() {
                api.getCurrentDirectionJudged().then(response => {
                    this.directionJudged = response.data;
                })
            },
            rightsContains(r) {
                let rights = this.userRights.split(",") || [];
                return rights.indexOf(RIGHTS_TYPE[r]) !== -1;
            },
            addStrategy() {
                if (this.strategyData.pair == "") {
                    this.$message.success('请输入交易对!');
                    return;
                }
                if (this.strategyData.exchangeEnum == "") {
                    this.$message.success('请输入目标交易所!');
                    return;
                }
                if (this.strategyData.thresholdNotPartition == "") {
                    this.$message.success('请输入美金对冲阈值!');
                    return;
                }
                if (this.strategyData.discountConform == "") {
                    this.$message.success('请输入顺势比例!');
                    return;
                }
                if (this.strategyData.discountSideways == "") {
                    this.$message.success('请输入震荡比例!');
                    return;
                }
                if (this.strategyData.discountOpposite == "") {
                    this.$message.success('请输入逆势比例!');
                    return;
                }
                api.addStrategy(this.strategyData).then(response => {
                    if (response.code == 0) {
                        this.dialogVisible = false;
                        this.$message.success('增加成功');
                        this.queryStrategyList(this.pageNo);
                    } else {
                        this.$message.success('增加失败');
                    }
                })
            },
            clearData() {
                this.strategyData = { //策略数据
                    pair: "",
                    open: true,
                    exchangeEnum: "",
                    thresholdNotPartition: 0,
                    discountConform: 0,
                    discountSideways: 0,
                    discountOpposite: 0
                }
            },
            updateStatus(row, value) {
                api.updateStrategyStatus({pair: row.pair, open: value ? 1 : 0}).then(response => {
                    if (response.code == 0) {
                        this.queryStrategyList(this.pageNo);
                    } else {
                        this.$message.success('操作失败');
                    }
                });
            },
        }
    }
</script>

<style scoped>

</style>
